 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84":"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84","AddAsk":"AddAsk","AddBirthdayContacts~UpdateContactBirthdate~UpdateProject":"AddBirthdayContacts~UpdateContactBirthdate~UpdateProject","AddBirthdayContacts":"AddBirthdayContacts","UpdateContactBirthdate":"UpdateContactBirthdate","AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6":"AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6","UpdateProject":"UpdateProject","AddIntroVideoContainer":"AddIntroVideoContainer","AddParticipantVideoContainer":"AddParticipantVideoContainer","AddVideoContainer~CreateBirthdayVideoContainer":"AddVideoContainer~CreateBirthdayVideoContainer","AddVideoContainer":"AddVideoContainer","CreateBirthdayVideoContainer":"CreateBirthdayVideoContainer","PlayAndJoinProject~PlayProject~RegisterBirthdayReminders":"PlayAndJoinProject~PlayProject~RegisterBirthdayReminders","PlayAndJoinProject":"PlayAndJoinProject","PlayProject":"PlayProject","RegisterBirthdayReminders":"RegisterBirthdayReminders","Slack":"Slack","SlackUserAddIntroVideoContainer":"SlackUserAddIntroVideoContainer","Done":"Done","Home":"Home","InvitePeople":"InvitePeople","JoinProjectAsParticipant":"JoinProjectAsParticipant","Login":"Login","ResetPassword":"ResetPassword","SendWelcome":"SendWelcome","SignUp":"SignUp","UnsubscribeEmail":"UnsubscribeEmail","UpdateInfo":"UpdateInfo","Credits":"Credits","InvitedParticipant":"InvitedParticipant","PlayTeamWelcome":"PlayTeamWelcome","Privacy":"Privacy","SignOut":"SignOut","Terms":"Terms","Thanks":"Thanks","about":"about"}[chunkId]||chunkId) + "." + {"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84":"ee300e3b","AddAsk":"b1d4a5db","AddBirthdayContacts~UpdateContactBirthdate~UpdateProject":"19dcdb17","AddBirthdayContacts":"9dd51572","UpdateContactBirthdate":"c26d0147","AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6":"f7ac4fec","UpdateProject":"1422cf6e","AddIntroVideoContainer":"9c0b88bc","AddParticipantVideoContainer":"3e2b6323","AddVideoContainer~CreateBirthdayVideoContainer":"531599c2","AddVideoContainer":"6348250a","CreateBirthdayVideoContainer":"2674305c","PlayAndJoinProject~PlayProject~RegisterBirthdayReminders":"3dd8dab8","PlayAndJoinProject":"422ac089","PlayProject":"776db2ae","RegisterBirthdayReminders":"09d7be97","Slack":"2316fc36","SlackUserAddIntroVideoContainer":"deddfb97","Done":"4431da3c","Home":"4ec8afca","InvitePeople":"2af863e4","JoinProjectAsParticipant":"5b6cc5a7","Login":"fe89ea11","ResetPassword":"4c2403bc","SendWelcome":"bedeadd1","SignUp":"edfbbad0","UnsubscribeEmail":"d538ad6f","UpdateInfo":"8ac35cfe","Credits":"916bd40d","InvitedParticipant":"6d681c76","PlayTeamWelcome":"c6f53b0d","Privacy":"7fafceed","SignOut":"677bce6e","Terms":"39de4af0","Thanks":"a5b33ef9","about":"318109dc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84":1,"AddAsk":1,"AddBirthdayContacts":1,"UpdateContactBirthdate":1,"UpdateProject":1,"AddIntroVideoContainer":1,"AddParticipantVideoContainer":1,"AddVideoContainer~CreateBirthdayVideoContainer":1,"AddVideoContainer":1,"CreateBirthdayVideoContainer":1,"PlayAndJoinProject~PlayProject~RegisterBirthdayReminders":1,"PlayAndJoinProject":1,"PlayProject":1,"RegisterBirthdayReminders":1,"Slack":1,"SlackUserAddIntroVideoContainer":1,"Done":1,"Home":1,"InvitePeople":1,"JoinProjectAsParticipant":1,"Login":1,"ResetPassword":1,"SendWelcome":1,"SignUp":1,"UnsubscribeEmail":1,"UpdateInfo":1,"Credits":1,"InvitedParticipant":1,"PlayTeamWelcome":1,"Privacy":1,"SignOut":1,"Terms":1,"Thanks":1,"about":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84":"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84","AddAsk":"AddAsk","AddBirthdayContacts~UpdateContactBirthdate~UpdateProject":"AddBirthdayContacts~UpdateContactBirthdate~UpdateProject","AddBirthdayContacts":"AddBirthdayContacts","UpdateContactBirthdate":"UpdateContactBirthdate","AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6":"AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6","UpdateProject":"UpdateProject","AddIntroVideoContainer":"AddIntroVideoContainer","AddParticipantVideoContainer":"AddParticipantVideoContainer","AddVideoContainer~CreateBirthdayVideoContainer":"AddVideoContainer~CreateBirthdayVideoContainer","AddVideoContainer":"AddVideoContainer","CreateBirthdayVideoContainer":"CreateBirthdayVideoContainer","PlayAndJoinProject~PlayProject~RegisterBirthdayReminders":"PlayAndJoinProject~PlayProject~RegisterBirthdayReminders","PlayAndJoinProject":"PlayAndJoinProject","PlayProject":"PlayProject","RegisterBirthdayReminders":"RegisterBirthdayReminders","Slack":"Slack","SlackUserAddIntroVideoContainer":"SlackUserAddIntroVideoContainer","Done":"Done","Home":"Home","InvitePeople":"InvitePeople","JoinProjectAsParticipant":"JoinProjectAsParticipant","Login":"Login","ResetPassword":"ResetPassword","SendWelcome":"SendWelcome","SignUp":"SignUp","UnsubscribeEmail":"UnsubscribeEmail","UpdateInfo":"UpdateInfo","Credits":"Credits","InvitedParticipant":"InvitedParticipant","PlayTeamWelcome":"PlayTeamWelcome","Privacy":"Privacy","SignOut":"SignOut","Terms":"Terms","Thanks":"Thanks","about":"about"}[chunkId]||chunkId) + "." + {"AddAsk~AddBirthdayContacts~AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~Cre~0c216e84":"1c031780","AddAsk":"cbec78f1","AddBirthdayContacts~UpdateContactBirthdate~UpdateProject":"31d6cfe0","AddBirthdayContacts":"352d7f75","UpdateContactBirthdate":"5a961dd5","AddIntroVideoContainer~AddParticipantVideoContainer~AddVideoContainer~CreateBirthdayVideoContainer~P~2246c3c6":"31d6cfe0","UpdateProject":"1e979879","AddIntroVideoContainer":"c7931c5d","AddParticipantVideoContainer":"ab6cb489","AddVideoContainer~CreateBirthdayVideoContainer":"1fea8a74","AddVideoContainer":"c6f98309","CreateBirthdayVideoContainer":"41ff4abb","PlayAndJoinProject~PlayProject~RegisterBirthdayReminders":"07f7affa","PlayAndJoinProject":"3e104193","PlayProject":"1939d139","RegisterBirthdayReminders":"9be6b5fd","Slack":"c9f65128","SlackUserAddIntroVideoContainer":"6cd3cc7b","Done":"7f5b16c0","Home":"5cbdeb90","InvitePeople":"61668e24","JoinProjectAsParticipant":"d0edf737","Login":"fcfdb351","ResetPassword":"ea9c8e26","SendWelcome":"099686b4","SignUp":"b3ac99b3","UnsubscribeEmail":"c8f387b2","UpdateInfo":"6501a53e","Credits":"beac4198","InvitedParticipant":"e310aeee","PlayTeamWelcome":"5425f8f2","Privacy":"e2228882","SignOut":"24323f98","Terms":"d5e8751b","Thanks":"5461b517","about":"f03bb266"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
